const COMPLIANT = Symbol('Compliant');
const NON_COMPLIANT = Symbol('NonCompliant');

export const ExampleCompliance = {
  COMPLIANT,
  NON_COMPLIANT,
} as const;

export type ExampleCompliance = (typeof ExampleCompliance)[keyof typeof ExampleCompliance];

type ExampleBuilder = {
  snippet: string;
  compliance: ExampleCompliance;
  description: string;
};

export class Example {
  readonly #snippet: string;
  readonly #compliance: ExampleCompliance;
  readonly #description: string;

  private constructor(builder: ExampleBuilder) {
    this.#snippet = builder.snippet;
    this.#compliance = builder.compliance;
    this.#description = builder.description;
  }

  static of(builder: ExampleBuilder): Example {
    return new Example(builder);
  }

  get snippet(): string {
    return this.#snippet;
  }

  get compliance(): ExampleCompliance {
    return this.#compliance;
  }

  get description(): string {
    return this.#description;
  }
}
